import { createContext, useContext } from 'react';
import { noop } from '../../utils';
export var DropdownContext = /*#__PURE__*/createContext({
  isVisible: true,
  close: noop
});
export var useDropDown = function useDropDown() {
  return useContext(DropdownContext);
};